import type { FunctionalComponent } from 'vue'
import type { IIconContainerProps } from './types'
import Icon from '../icon'

const IconContainer: FunctionalComponent<IIconContainerProps> = (
  props: IIconContainerProps,
  { slots }
) => {
  const { icon, iconBgColor, iconBgClass, size, containerSize  } = props

  const w =
    {
      default: '2.5rem',
      xs: '0.75rem',
      sm: '1rem',
      md: '4rem',
      lg: '8rem'
    }[size || 'default'] || '2.5rem'

  const iconSize =
    {
      default: undefined,
      xs: 12,
      sm: 16,
      md: 32,
      lg: 48
    }[size || 'default'] || undefined

  return (
    <div
      class={`rounded-xs ${iconBgClass || ''}`}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        verticalAlign: 'middle',
        width: containerSize ? `${containerSize}px` : w,
        height: containerSize ? `${containerSize}px` : w,
        textAlign: 'center',
        ...(iconBgClass
          ? {}
          : {
              backgroundColor: iconBgColor || '#E1EFFE'
            })
      }}
    >
      {icon && <Icon size={props.iconSize || iconSize} stroke="currentColor" src={icon} />}
      {slots.default ? slots.default() : null}
    </div>
  )
}

IconContainer.props = ['icon', 'iconBgColor', 'iconBgClass', 'size', 'containerSize']
export default IconContainer
